import React, { FC } from 'react';
import Safe from 'react-safe';
import getConfig from 'next/config';
import Head from 'next/head';

export const Scripts: FC<{ email: string }> = ({ email }) => {
  const { publicRuntimeConfig } = getConfig();
  const { production } = publicRuntimeConfig;

  return (
    <Head>
      <Safe.script async>
        {`
          (function () { 
            function loadKlaviyo() {
              setTimeout(function() {
                var klv = document.createElement('script');
                klv.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=PqHk72';
                klv.async = true;
                document.getElementsByTagName('head')[0].appendChild(klv);
              }, 1000);
            }
            loadKlaviyo();
          })();
        `}
      </Safe.script>
      {email && (
        <Safe.script>
          {`
          var _learnq = _learnq || [];
          _learnq.push(['identify', {
            '$email': '${email}',
          }]);
      `}
        </Safe.script>
      )}
      {/* eslint-disable-next-line no-undef */}
      {production && (
        <>
          <Safe.script type="text/javascript">
            {`
                const _urconfig = { sid: "a5975b5e-4c16-4b93-b8e6-51751ee02379", aip: 0, usePageProtocol: false };
              `}
          </Safe.script>
          <Safe.script type="text/javascript">
            {`
                (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"25032235"};
                o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,
                n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||
                (f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],
                i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");
              `}
          </Safe.script>
          <meta content="9F4A590BE8C37963A7B3893776DFE82F" name="msvalidate.01" />
        </>
      )}
      <Safe.script>{`!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t){var e=document.createElement("script");e.type="text/javascript";e.async=!0;e.src=("https:"===document.location.protocol?"https://":"http://")+"cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};analytics.SNIPPET_VERSION="4.0.0";}}();`}</Safe.script>
    </Head>
  );
};
